import {Action, ActionHackCtx, IAction} from "lib/commons/actions";
import {IReg, IRegPointer, REG} from 'lib/commons/registry';
import {JSX} from "lib/commons/xml/dom";
import "back/wsp/plugins/plugins_Perms";
import {CoreUniverse, IUniverseEnv} from "lib/core/universe";
import {POPUP} from "back/commons/widgets/popups";
import {OPacksMgrInit, SkinPacksMgr, WspPacksMgr} from "back/wsp/dialogs/packsMgr";
import {IPacksInUniverse} from "lib/wsp/pack";

/**
 * Gestionnaire global de packs
 *
 * @param reg Registre à exploiter correspondant
 * @param contexte reg :
 * 	- liste des univers à traiter : "plg:packs:universes"
 */
export function initApp(reg: IReg<IUniverseEnv> = REG.reg) {

	class WrapReg extends ActionHackCtx<Element, IReg<IUniverseEnv>> {
		constructor(sub: IAction<IReg<IUniverseEnv>>, public reg: IReg<IUniverseEnv>) {
			super(sub);
		}

		wrapCtx(ctx: Element): IReg<IUniverseEnv> {return this.reg}

		initButtonNode(buttonNode: Element, ctx: Element) {
			//Affectation du bon registre dans le contexte graphique.
			(buttonNode as IRegPointer<IUniverseEnv>).reg = this.reg;
			this.sub.initButtonNode(buttonNode, this.reg);
		}
	}

	function wrap(action: IAction<IReg<IUniverseEnv>>): IAction<Element> {
		return new WrapReg(action, reg);
	}

	//Menu Options
	REG.reg.addToList("appframe:header:toolbar:params", "wsppacks", 1, wrap(new OpenPackMgr().requireVisiblePerm("ui.wspPacksMgr")), 10);
	REG.reg.addToList("appframe:header:toolbar:params", "skinpacks", 1, wrap(new OpenSkinMgr().requireVisiblePerm("ui.skinPacksMgr")), 11);

}


/**
 * Ouverture du gestionnaire de packs
 */
export class OpenPackMgr extends Action<IReg<IUniverseEnv>> {

	constructor() {
		super("packMgr");
		this._label = "Modèles documentaires...";
		this._group = 'packs';
	}

	async execute(ctx: IReg<IUniverseEnv>, ev?: Event) {
		const MOD = await import("back/wsp/dialogs/packsMgr.js");
		const ct = new MOD.WspPacksMgr().initialize({
			reg: ctx.reg,
			universes: regUniversesList(ctx.reg),
		} as OPacksMgrInit);
		await POPUP.showDialog(ct, null, {
			titleBar: {barLabel: {label: "Modèles documentaires"}, closeButton: {}},
			resizer: {},
			viewPortX: "middle",
			viewPortY: "middle",
			initWidth: "max(60em, 40vw)",
			initHeight: "70vh"
		}).onNextClose();
	}

	isVisible(ctx: IReg<IUniverseEnv>): boolean {
		if (!super.isVisible(ctx)) return false;
		return WspPacksMgr.isAvailable(regUniversesList(ctx.reg));
	}
}

/**
 * Ouverture du gestionnaire de skins
 */
export class OpenSkinMgr extends Action<IReg<IUniverseEnv>> {

	constructor() {
		super("skinMgr");
		this._label = "Habillages graphiques des modèles...";
		this._group = 'packs';
	}

	async execute(ctx: IReg<IUniverseEnv>, ev?: Event) {
		const MOD = await import("back/wsp/dialogs/packsMgr.js");
		const ct = new MOD.SkinPacksMgr().initialize({
			reg: ctx.reg,
			universes: regUniversesList(ctx.reg),
		} as OPacksMgrInit);
		await POPUP.showDialog(ct, null, {
			titleBar: {barLabel: {label: "Habillages graphiques des modèles"}, closeButton: {}},
			resizer: {},
			viewPortX: "middle",
			viewPortY: "middle",
			initWidth: "max(60em, 40vw)",
			initHeight: "70vh"
		}).onNextClose();
	}

	isVisible(ctx: IReg<IUniverseEnv>): boolean {
		if (!super.isVisible(ctx)) return false;
		return SkinPacksMgr.isAvailable(regUniversesList(ctx.reg));
	}
}

/**
 *
 * @param reg
 */
function regUniversesList(reg: IReg<IUniverseEnv>): (CoreUniverse & IPacksInUniverse)[] {
	return reg.getList("plg:packs:universes");
}